import { useEffect, useState } from "react";
import { api } from "../lib/api";

// saved MDF / edge-band colours offered as suggestions on every colour input (list="mdf-colors" / "edge-colors")
export const ColorLists = ({ extra = [] }) => {
  const [c, setC] = useState({ mdf: [], edge: [] });
  useEffect(() => {
    api.get("/colors").then((r) => setC(r.data)).catch(() => {});
  }, []);
  const all = extra.flatMap((p) => (p ? [p, p.tampon || {}] : []));
  const mdf = [...new Set([...c.mdf, ...all.map((p) => p.mdf_color?.trim()).filter(Boolean)])];
  const edge = [...new Set([...c.edge, ...all.map((p) => p.edge_color?.trim()).filter(Boolean)])];
  return (
    <>
      <datalist id="mdf-colors" data-testid="mdf-colors-list">{mdf.map((v) => <option key={v} value={v} />)}</datalist>
      <datalist id="edge-colors" data-testid="edge-colors-list">{edge.map((v) => <option key={v} value={v} />)}</datalist>
    </>
  );
};
